import { map, tap } from "rxjs/operators";
import { ApiResponse } from "@core/models/api-response.model";
import { HttpClient } from "@angular/common/http";
import { Observable, Subject } from "rxjs";
import { DefaultDataService, HttpUrlGenerator } from "@ngrx/data";
import { Injectable } from "@angular/core";
import { Pagination } from "@core/models/pagination.model";
import { GameTypeReport } from "@core/models/gametype-report.model";

@Injectable()
export class GameTypeReportDataService extends DefaultDataService<GameTypeReport> {
  pagination: Pagination;
  messages$ = new Subject<any[]>();

  constructor(http: HttpClient, httpUrlGenerator: HttpUrlGenerator) {
    super('GameTypeReport', http, httpUrlGenerator, { root: '' });
  }

  getWithQuery(pageParam: string): Observable<GameTypeReport[]> {
    return this.http
      .get<ApiResponse>(`/report/gametype${pageParam}`)
      .pipe(
        tap((res) => {
          this.paginationInit(res);
        }),
        map((res) => res.data.rows)
      );
  }

  getOptions() {
    return this.http.get<ApiResponse>(`/gametypereport/options`).pipe(
        map((res) => res.data.rows)
    );
  }

  exportReport (pageParam: string) {
    return this.http.get<ApiResponse>(`/report/exportgametype${pageParam}`).pipe(
      tap(res => this.messages$.next(res.message))
    );
  }

  private paginationInit(res: any) {
    if (res) {
      return (this.pagination = res.data.paginations);
    }
  }
}
